<template>
  <md-field class="search-field">
    <md-input :placeholder="placeholder" v-model="internalValue" />
    <fa-icon
      v-if="!noClear && internalValue.trim() != ''"
      icon="times"
      @click="internalValue = ''"
    />
  </md-field>
</template>

<script>
import { clearInterval, setInterval } from 'timers'

// 성능을 위해 키보드 입력이 멈추면 이벤트를 날려주도록 일정 시간을 기다리도록 한다.
// 아래 숫자를 늘리면 최종 결과가 더 늦게 나오고, 줄이면 필터링을 더 자주해서 CPU를 많이 쓴다.
const INPUT_DELAY_MS = 200

export default {
  data: () => ({
    langKey: 'admin.searchField',
    interval: null,
  }),

  props: {
    value: String,
    fields: [Object, Array],
    noClear: Boolean,
    customValue: String,
  },

  computed: {
    internalValue: {
      get() {
        return this.value
      },

      set(v) {
        if (this.interval) {
          clearInterval(this.interval)
          this.interval = null
        }

        this.interval = setInterval(() => {
          this.$emit('input', v)
        }, INPUT_DELAY_MS)
      },
    },

    internalFields() {
      if (Array.isArray(this.fields)) {
        return this.fields.map((field) => ({
          field,
          label: this.L(field),
        }))
      }

      return Object.keys(this.fields).map((field) => ({
        field,
        label: this.L(this.fields[field]),
      }))
    },

    placeholder() {
      const labels = this.internalFields.map((f) => f.label).join(', ')
      return !this.customValue
        ? `${this.L('searchBy')} ${labels}...`
        : this.customValue
    },
  },
}
</script>

<style scoped>
.search-field {
  min-height: 32px;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 6px;
  margin-bottom: 6px;
}
.search-field input {
  display: inline-block;
  width: 100%;
}
</style>
